import React from 'react';
import './Experience.css';

const Experience = ({ experiences = [] }) => {
  const toPeriod = (start, end) => {
    if (!start && !end) return '';
    return `${start || ''} ${end ? `- ${end}` : '- Present'}`.trim();
  };

  return (
    <section id="experience" className="experience">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Professional Experience</h2>
        </div>

        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-marker">
                <div className="marker-dot"></div>
                {index < experiences.length - 1 && <div className="marker-line"></div>}
              </div>

              <div className="timeline-content">
                <div className="experience-card">
                  <div className="experience-header">
                    <h3 className="experience-title">{exp.title || exp.position}</h3>
                    <div className="experience-company">{exp.company}</div>
                    <div className="experience-period">{exp.period || toPeriod(exp.start_date, exp.end_date)}</div>
                  </div>

                  <p className="experience-description">{exp.description}</p>

                  {exp.achievements && exp.achievements.length > 0 && exp.achievements.some(ach => (ach.achievement || ach) && String(ach.achievement || ach).trim() !== '') && (
                    <div className="experience-achievements">
                      <h4 className="achievements-title">Key Achievements:</h4>
                      <ul className="achievements-list">
                        {(exp.achievements || []).filter(ach => (ach.achievement || ach) && String(ach.achievement || ach).trim() !== '').map((achievement, idx) => (
                          <li key={idx} className="achievement-item">
                            <span className="achievement-icon">✓</span>
                            {achievement.achievement || achievement}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;

